import * as angular from 'angular';
import { config } from 'angular/utils/config';

(function () {
    'use strict';

    angular.module('app').controller('MarketMessagesCtrl', MarketMessagesCtrl);

    function MarketMessagesCtrl(
        $location,
        $routeParams,
        $anchorScroll,
        MarketsMessages,
        DATES
    ) {
        var vm = this;

        vm.DATES = DATES;
        vm.marketMessages = null;
        vm.getMessages = getMessages;
        vm.getRssLink = getRssLink;
        vm.monthKeyToVal = monthKeyToVal;
        vm.errorLoading = false;
        vm.loading = false;

        vm.paginator = {
            totalMarketMessages: 0,
            marketMessagesPerPage: 15,
            currentPage: 1
        };
        vm.search = {
            years: [],
            months: [
                { key: 'January', val: 1 },
                { key: 'February', val: 2 },
                { key: 'March', val: 3 },
                { key: 'April', val: 4 },
                { key: 'May', val: 5 },
                { key: 'June', val: 6 },
                { key: 'July', val: 7 },
                { key: 'August', val: 8 },
                { key: 'September', val: 9 },
                { key: 'October', val: 10 },
                { key: 'November', val: 11 },
                { key: 'December', val: 12 }
            ],
            year: new Date().getFullYear(),
            month: null,
            showUrgentMessagesOnly: false
        };
        vm.marketMessagesLoaded = marketMessagesLoaded;
        for (var i = 0; i < 5; i++) {
            vm.search.years.push(vm.search.year - i);
        }

        vm.ummLocation = $location.path();
        if ($routeParams.messageId) {
            vm.ummRouteId = $routeParams.messageId;
        }

        getMessages(1);

        /**
         * Request paginated market messages.
         *
         * @param pageNumber {number} The page number to navigate to
         */
        function getMessages(pageNumber) {
            vm.loading = true;

            var successCb = function (res) {
                vm.marketMessages = res.data;
                vm.paginator.totalMarketMessages = res.totalSize;
                vm.errorLoading = false;
            };
            var errorCb = function (err) {
                vm.errorLoading = true;
            };
            var finallyCb = function () {
                vm.loading = false;
            };

            if (pageNumber) {
                MarketsMessages.archived(
                    {
                        year: vm.search.year,
                        month: vm.search.month,
                        urgentMessagesOnly: vm.search.showUrgentMessagesOnly,
                        pageSize: vm.paginator.marketMessagesPerPage,
                        start:
                            (pageNumber - 1) *
                            vm.paginator.marketMessagesPerPage
                    },
                    successCb,
                    errorCb
                ).$promise.finally(finallyCb);
            } else {
                MarketsMessages.archived(
                    {
                        year: vm.search.year,
                        month: vm.search.month,
                        urgentMessagesOnly: vm.search.showUrgentMessagesOnly
                    },
                    successCb,
                    errorCb
                ).$promise.finally(finallyCb);
            }
        }

        function getRssLink(messageType) {
            var protocolHost = $location.protocol() + '://' + $location.host();
            var rssLink =
                config.monolithApi +
                '/marketMessages/rss?messageType=' +
                messageType +
                '&externalServerURL=' +
                protocolHost;
            if ($location.port()) {
                rssLink += ':' + $location.port();
            }
            return rssLink + '/';
        }

        function scrollToMessage(messageId) {
            var old = $location.hash();
            $location.hash('message' + messageId);
            $anchorScroll();
            //reset to old to keep any additional routing logic from kicking in
            $location.hash(old);
        }

        function marketMessagesLoaded() {
            if ($routeParams.messageId) {
                scrollToMessage($routeParams.messageId);
            }
        }

        function monthKeyToVal(val: number): string | null {
            if (!val) {
                return;
            }
            return vm.search.months.find((month) => month.val === val).key;
        }
    }
})();
